import { render, staticRenderFns } from "./Editions.vue?vue&type=template&id=52c6254c&scoped=true&"
import script from "./Editions.vue?vue&type=script&lang=js&"
export * from "./Editions.vue?vue&type=script&lang=js&"
import style0 from "./Editions.vue?vue&type=style&index=0&id=52c6254c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c6254c",
  null
  
)

export default component.exports